import { LoaderCircle, X } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MARKET_INSIGHTS_PDF } from "@/data/portalConfig";
import { api } from "@/lib/api";

const initialForm = { name: "", phone: "", email: "" };

export const MarketInsightsModal = ({ contextLabel, onClose, open, testIdPrefix = "market-insights" }) => {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) setForm(initialForm);
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await api.post("/contact-lead", {
        ...form,
        inquiry_type: "market-insights-download",
        lead_source: "homepage",
        capture_context: contextLabel || "Homepage market insights modal",
        captured_route: window.location.pathname,
        notes: `Requested 2026 Market Insights. Context: ${contextLabel}`,
      });
      toast.success("2026 Market Insights unlocked successfully");
      window.open(MARKET_INSIGHTS_PDF, "_blank", "noopener,noreferrer");
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Unable to unlock the report right now");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[75] flex items-center justify-center bg-black/75 px-4 py-8 backdrop-blur-sm" data-testid={`${testIdPrefix}-overlay`}>
      <div className="luxury-panel w-full max-w-lg p-6 md:p-8" data-testid={`${testIdPrefix}-panel`}>
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <p className="subtle-label">Seller Lead Magnet</p>
            <h3 className="mt-2 text-3xl font-semibold text-white" data-testid={`${testIdPrefix}-title`}>
              Download 2026 Market Insights
            </h3>
            <p className="mt-2 text-sm leading-7 text-slate-300">
              Share your details to unlock the branded Navy-and-Gold PDF with district cues, seller timing notes, and April 2026 tax guidance.
            </p>
          </div>
          <button className="rounded-full border border-white/10 bg-white/5 p-3 text-white" data-testid={`${testIdPrefix}-close-button`} onClick={onClose} type="button">
            <X className="h-4 w-4" />
          </button>
        </div>

        <form className="grid gap-4" onSubmit={handleSubmit}>
          <input className="field-shell" data-testid={`${testIdPrefix}-name-input`} onChange={(event) => setForm({ ...form, name: event.target.value })} placeholder="Full Name" required value={form.name} />
          <input className="field-shell" data-testid={`${testIdPrefix}-phone-input`} onChange={(event) => setForm({ ...form, phone: event.target.value })} placeholder="Phone Number" required value={form.phone} />
          <input className="field-shell" data-testid={`${testIdPrefix}-email-input`} onChange={(event) => setForm({ ...form, email: event.target.value })} placeholder="Email Address" required type="email" value={form.email} />
          <button className="gold-button w-full" data-testid={`${testIdPrefix}-submit-button`} disabled={loading} type="submit">
            {loading ? <LoaderCircle className="mr-2 h-4 w-4 animate-spin" /> : null}
            Unlock PDF
          </button>
        </form>
      </div>
    </div>
  );
};